import React from "react";

import { usePageURL } from "../../../utils/urls";
import { useAppSelector } from "../../reducers";
import { defaultState } from "../defaults";
import { buildReviewsURL, getParamsFromFacetValues } from "../history";

interface IProps {
    className: string;
    children?: React.ReactNode;
}

export const ReviewsPageLink = (props: IProps) => {
    const productTypeIDs = useAppSelector(
        (state) => (state.reviews || defaultState).ui.productTypeIDs,
    );
    const facetValues = useAppSelector(
        (state) => (state.reviews || defaultState).ui.facetValues,
    );

    const reviewsURL = usePageURL("reviews_link");
    const homeURL = usePageURL("home");
    const baseURL = reviewsURL || homeURL;
    if (!baseURL) {
        return null;
    }
    const params = getParamsFromFacetValues(facetValues, productTypeIDs);
    const url = buildReviewsURL(baseURL, params);
    return (
        <a href={url} className={props.className}>
            {props.children}
        </a>
    );
};
